import settings from '../settings/animation';

export const animation = (name) => ({
  animationName: name,
  animationDuration: `${settings.duration}ms`,
  animationTimingFunction: settings.timingFunction,
});

export const transition = (...properties) => transitionDuration(settings.duration, ...properties);

export const transitionDuration = (duration, ...properties) => ({
  transitionProperty: properties.join(', '),
  transitionDuration: typeof duration === 'number' ? `${duration}ms` : duration,
  transitionTimingFunction: settings.timingFunction,
});

export default {
  animation,
  transition,
  transitionDuration,
};
